export const MASKED_INPUT_TEST_IDS = {
  promptPlaceholder: 'prompt-placeholder',
} as const;
